module.exports = __webpack_public_path__ + "static/media/instagram_icon.9ce2001e.svg";